module.exports = __webpack_public_path__ + "img/gy_img7.42a24c37.png";